var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 5C4.75 3.75736 5.75736 2.75 7 2.75H11.7574C12.3541 2.75 12.9264 2.98705 13.3483 3.40901L13.8787 2.87868L13.3483 3.40901L18.591 8.65165C19.0129 9.07361 19.25 9.6459 19.25 10.2426V19C19.25 20.2426 18.2426 21.25 17 21.25H7C5.75736 21.25 4.75 20.2426 4.75 19V5Z",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V8C12 9.10457 12.8954 10 14 10H19",
    stroke: "#272932",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00995 17.3808H7.83653V16.1132H8.5314C9.43052 16.1132 9.95358 15.5768 9.95358 14.796C9.95358 14.0191 9.44006 13.4712 8.55239 13.4712H7.00995V17.3808ZM7.83653 15.4508V14.147H8.39395C8.87119 14.147 9.10218 14.4066 9.10218 14.796C9.10218 15.1835 8.87119 15.4508 8.39777 15.4508H7.83653Z",
    fill: "#272932"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8764 17.3808C13.0676 17.3808 13.7892 16.6439 13.7892 15.4222C13.7892 14.2042 13.0676 13.4712 11.8878 13.4712H10.4905V17.3808H11.8764ZM11.3171 16.6725V14.1794H11.8439C12.577 14.1794 12.9645 14.5536 12.9645 15.4222C12.9645 16.2946 12.577 16.6725 11.842 16.6725H11.3171Z",
    fill: "#272932"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4015 17.3808H15.2281V15.7658H16.8182V15.0843H15.2281V14.1527H16.99V13.4712H14.4015V17.3808Z",
    fill: "#272932"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfFile);
export default __webpack_public_path__ + "static/media/pdf_file.1957c0c6a8b37fc0fa548c3926fc4032.svg";
export { ForwardRef as ReactComponent };